import { Navigate, Outlet } from "react-router";
import { NAVIGATION_MENU, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";

export const NavigationMenuProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(VIEW, NAVIGATION_MENU)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
